import { render, staticRenderFns } from "./AddSchedaModal.vue?vue&type=template&id=139de08e&"
import script from "./AddSchedaModal.vue?vue&type=script&lang=js&"
export * from "./AddSchedaModal.vue?vue&type=script&lang=js&"
import style0 from "./AddSchedaModal.vue?vue&type=style&index=0&id=139de08e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports